import { render, staticRenderFns } from "./UserVerification.vue?vue&type=template&id=8363dbee&scoped=true"
import script from "./UserVerification.vue?vue&type=script&lang=js"
export * from "./UserVerification.vue?vue&type=script&lang=js"
import style0 from "./UserVerification.vue?vue&type=style&index=0&id=8363dbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8363dbee",
  null
  
)

export default component.exports